import { Step, StepLabel, Stepper, makeStyles } from '@material-ui/core';
import React from 'react';
import useStepperStyles from './stepper.styles';

interface PropsSvbStepperState {
  totalSteps: number;
  activeStep: number;
}

export const SvbStepper: React.FC<PropsSvbStepperState> = ({ totalSteps, activeStep = 0 }) => {
  const { stepper } = useStepperStyles();
  const customStepperIcon = (props): JSX.Element => {
    const { active, completed } = props;
    return (
      <span className={`stepper__icon ${active ? 'active' : ''} ${completed ? 'completed' : ''}`} />
    );
  };
  return (
    <div className={stepper}>
      <Stepper alternativeLabel activeStep={activeStep}>
        {Array.from({ length: totalSteps }, (_, i) => (
          <Step key={i}>
            <StepLabel StepIconComponent={customStepperIcon} />
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

